import { render } from "./Avatar.vue?vue&type=template&id=20cd3d58"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/settings/Avatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20cd3d58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20cd3d58', __exports__)) {
    api.reload('20cd3d58', __exports__)
  }
  
  module.hot.accept("./Avatar.vue?vue&type=template&id=20cd3d58", () => {
    api.rerender('20cd3d58', render)
  })

}


export default __exports__